import { createAsyncSelectors } from '@lib/selectors';
export const getTimelineDetailsSelector = createAsyncSelectors((state) => state.core.timeline.details.get);
export const getTimelineGroupedSummarySelector = createAsyncSelectors((state) => state.core.timeline.groupedSummary.get);
export const getTimelineSummarySelector = createAsyncSelectors((state) => state.core.timeline.summary.get);
export const getTimelineSynopsisSelector = createAsyncSelectors((state) => state.core.timeline.synopsis.get);
export const getTimelineUserChangesSelector = createAsyncSelectors((state) => state.core.timeline.userChanges.get);
